/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<
  defs.tms.IPage<defs.tms.LogisticsQuotationTobResponseDto>
>;
export function request(
  params: API.tms.logisticsQuotationTob.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsQuotationTob/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
